/**
 * Ícono de Font Awesome según el tipo de archivo. En la sección Archivos el tipo es lo primero que
 * se busca —«¿dónde está el Excel?»— y un ícono genérico para todo obliga a leer cada nombre.
 * Se mira el mime y, si no alcanza (muchos navegadores mandan `application/octet-stream` para un
 * .xlsx), la extensión.
 */
export function fileIconOf(mimeType: string | null | undefined, filename: string | null | undefined): string {
  const mime = (mimeType ?? '').toLowerCase()
  const ext = (filename ?? '').toLowerCase().split('.').pop() ?? ''
  if (mime.startsWith('image/')) return 'fa-solid fa-file-image'
  if (mime === 'application/pdf' || ext === 'pdf') return 'fa-solid fa-file-pdf'
  if (mime.includes('spreadsheet') || mime.includes('excel') || ['xlsx', 'xls', 'csv'].includes(ext)) return 'fa-solid fa-file-excel'
  if (mime.includes('word') || ['docx', 'doc'].includes(ext)) return 'fa-solid fa-file-word'
  if (mime.includes('zip') || ['zip', 'rar', '7z'].includes(ext)) return 'fa-solid fa-file-zipper'
  if (mime.startsWith('video/')) return 'fa-solid fa-file-video'
  return 'fa-solid fa-file'
}

/** Tamaño legible. KB/MB basta: no hay adjuntos de gigabytes en una tarea. */
export function fileSizeLabel(bytes: number | null | undefined): string {
  if (!bytes) return ''
  //* Por debajo de 1 KB se redondeaba a "0 KB", que se lee como archivo vacío.
  if (bytes < 1024) return `${bytes} B`
  return bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} KB` : `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
